import React from 'react'
import defaultClasses from './testimonials.module.scss'
import { string } from 'prop-types'
import Slider from 'react-slick'
import { useIsArabic } from '@components/common/IsArabic/useIsArabic'

const testimonialSliderSettings = {
    slidesToShow: 1,
    speed: 300,
    infinite: true,
    autoplay: false,
    accessibility: false,
    cssEase: 'linear',
    rtl: false,
    arrows: true,
    dots: false,
    pauseOnFocus: false,
    responsive: [
        {
            breakpoint: 1023,
            settings: {
                arrows: false,
                dots: true
            }
        }
    ]
}

const Testimonial = (props) => {
    const { children } = props
    const isArabic = useIsArabic()

    return (
        <div className={defaultClasses['testimonial-wrapper']}>
            <div className={defaultClasses['testimonial-slide']}>
                <Slider {...{ ...testimonialSliderSettings, rtl: isArabic }}>
                    {children}
                </Slider>
            </div>
        </div>
    )
}

Testimonial.propTypes = {
    testimonial: string
}

export default Testimonial
